export const baseTypeOptions = [
	{
		value: 'month',
		name: 'měsíční',
	},
	{
		value: 'day',
		name: 'denní',
	},
];
